import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { RuleDao } from '../model/rule-dto';

@Injectable({
    providedIn: 'root'
  })
  export class RuleService{

    constructor(private _restClientService : RestClientService) 
    {}
    
    getRulesByNamespace(ruleNamespace) 
    {
        return this._restClientService.load<RuleDao[]>('rule/get-all-rules/'+ruleNamespace);
    }
    
    getRuleById(ruleId){
        return this._restClientService.load<RuleDao>('rule/get-rule-by-id/'+ruleId);
    }
    
    update(ruleDao: RuleDao) {
        return  this._restClientService.put<RuleDao>(`rule/update`, ruleDao);
    }
        
    add(ruleDao: RuleDao) {
    return  this._restClientService.save<RuleDao>('rule/add', ruleDao);
    }
      
}